var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3289 0 0 14.3289 0 32C0 49.6711 14.3289 64 32 64C49.6711 64 64 49.6711 64 32C64 14.3289 49.6711 0 32 0ZM32 59.4286C16.8737 59.4286 4.57143 47.1264 4.57143 32C4.57143 16.8737 16.8737 4.57143 32 4.57143C47.1264 4.57143 59.4286 16.8737 59.4286 32C59.4286 47.1264 47.1264 59.4286 32 59.4286Z",
    fill: "#39A757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.099 21.2419L27.4286 37.9124L19.901 30.3847C19.007 29.4908 17.5594 29.4908 16.6705 30.3847C15.7765 31.2787 15.7765 32.7263 16.6705 33.6152L25.8133 42.7581C26.2603 43.2051 26.8444 43.4286 27.4286 43.4286C28.0127 43.4286 28.5968 43.2051 29.0438 42.7581L47.3295 24.4724C48.2235 23.5784 48.2235 22.1308 47.3295 21.2419C46.4356 20.3479 44.9879 20.3479 44.099 21.2419Z",
    fill: "#39A757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessOutlined);
export default __webpack_public_path__ + "static/media/success-outlined.14fa9cb7a04b09ce2add80eaa2ecfaaf.svg";
export { ForwardRef as ReactComponent };